import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../service/data.service';
import { UserService } from '../service/user.service';
import { User } from '../_models/user';
import { AlertService } from '../service/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BotDetectCaptchaModule } from 'angular-captcha';
import { CaptchaComponent } from 'angular-captcha';

import { MyDatePickerModule, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import { NgModule, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {IMyDpOptions, IMyDateModel, IMyOptions} from 'mydatepicker';
import { Observable } from 'rxjs';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
declare var getHexAscii: any;
declare var currentYear:any;
declare var currentDate:any;
declare var currentMonth:any;
declare var mytime:Date;
@Component({
  selector: 'app-forgot-user-id',
  templateUrl: './forgot-user-id.component.html',
  styleUrls: ['./forgot-user-id.component.css'],  
   providers: [DataService]
})
export class ForgotUserIdComponent implements OnInit {
    forgotForm: FormGroup;
    messageForcustnumber:string;
   msgforCustNoSpace:string;
   msgforCustNoSplChar:string;
   msgforcustnoonly:string;
   messageFormMobNoreq:string;
   msgforMobNoSpace:string;
   msgforMobNoSplChar:string;
   msgforMobNonly:string;
   msgforMobNoLen:string;
  messageForDatereq:string;
  messageForCaptchareq:string;
    returnUrl: string;
   captchatNoblank:string;
   incorrectCaptcha:string;
    regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/;
    regchar='/^[a-zA-Z]+$/';
    regexpspace=/\s+/;
    regZeroOnly='^[0][0]*[0]$';
   regNum = '^[0-9]*$';
    regexcap =/^.*?[A-Z]/;
  isError = 'false';
    errorDescription = ' ';
  isLoad = false;
   placeholder:string;
  Errorflagcap:string="no";
  Errorflaguser:string="no";
  Errorflagcust:string="no";
  Errorflagmob:string="no";
  Errorflagdate:string="no";
  readonlyflag="false";
    mytime:Date = new Date();
    isDisabled : boolean = false;
    currentYear:any= this.mytime.getUTCFullYear();
    currentDate:any= this.mytime.getUTCDate()+1;
    currentMonth:any= this.mytime.getUTCMonth() + 1; 
 myDatePickerOptions: IMyDpOptions = {
        inline: false,
        dateFormat: 'dd-mm-yyyy',
        editableDateField:false,
        disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate}
    };
  bankName: Observable<string>;
  atmBranch: string;
  contactUsPage: string;

  constructor(   private router: Router,
        private fb: FormBuilder,
        private userService: UserService,
         private route: ActivatedRoute,
          private webService: CallBackEndService,
        private alertService: AlertService,
           private spinnerService: Ng4LoadingSpinnerService,
           private http : HttpClient

    ) {
      this.bankName = webService.getBankName();
      this.getJSON().subscribe(data => {
        this.atmBranch = data.atmBranch;
        this.contactUsPage = data.contactUsPage;
       });    
      
     this.Errorflagcap="no";
                    this. Errorflaguser="no";
                    this. Errorflagcust="no";
                     this. Errorflagmob="no";
                      this. Errorflagdate="no";
      this.forgotForm = fb.group({
      'CustomerNo' : [null, Validators.required],
      'MobNo' : [null, Validators.required],
       'date' : [null, Validators.required],
        'captcha' : [null, Validators.required],
         'captchaInput' : [null, Validators.required],
          });
       this.getCaptcha();
       
     }
      public getJSON(): Observable<any> {
        return this.http.get('assets/SampleUrl.json'); 
      }
forgotUserSubmit(){
   
      this.isDisabled = true ;
     // this.validateCaptcha();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      let date1=this.forgotForm.controls['date'];
        let date2=date1.value;
        let mobno1=this.forgotForm.controls['MobNo'];
        let captcha=this.forgotForm.controls['captchaInput'];
         let custno=this.forgotForm.controls['CustomerNo'];
    let captchaWithoutSpaceNew = this.forgotForm.controls['captcha'].value.split(' ').join('');
        if (custno.value === '' ||custno.value===' '||custno.value===undefined||custno.value===null) 
    {
     console.log("In iff"+custno.value);
     this.messageForcustnumber = 'no';
     this.Errorflagcust="no";

   }else if(custno.value.match(this.regexpspace))
    {
      this.msgforCustNoSpace= 'no';
      this.Errorflagcust="no";
    }else if(custno.value.match(this.regsplchar))
    {
      this.msgforCustNoSplChar= 'no';
      this.Errorflagcust="no";
    }else if(!custno.value.match(this.regNum))
    {
      this.msgforcustnoonly = 'no';
      this.Errorflagcust="no";
     }else if (mobno1.value === '' ||mobno1.value===' ' ||mobno1.value===undefined||mobno1.value===null) 
     {
      this.messageFormMobNoreq = 'no';
      this. Errorflagmob="no";
     }else if(mobno1.value.match(this.regexpspace))
     {
      this.msgforMobNoSpace= 'no';
       this. Errorflagmob="no";
     }else if(mobno1.value.match(this.regsplchar))
    {
      this.msgforMobNoSplChar= 'no';
       this. Errorflagmob="no";
     }else if(!mobno1.value.match(this.regNum))
    {
      this.msgforMobNonly = 'no';
     }else if(mobno1.value.length>10||mobno1.value.length<10)
    {
      this.msgforMobNoLen = 'no';
       this. Errorflagmob="no";
     }  else if (date2==='""'||date2==='" "'||date2==='"  "' ||date2===undefined||date2===null) 
    {
     this.messageForDatereq = 'no';
     this.Errorflagdate="no";
   }else if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null) 
    {
     this.captchatNoblank = 'no';
     
     
      
   }else if(captcha.value!==captchaWithoutSpaceNew)
     { 
      this.incorrectCaptcha='no';
      this.Errorflagcap="no";
       
    }else{
       this.spinnerService.show();
        request.param5=date2['date'].day+"-"+this.getMonthName(date2['date'].month)+"-"+date2['date'].year;
      request.param1 = getHexAscii('', this.forgotForm.get("CustomerNo").value+this.forgotForm.get("MobNo").value+request.param5);
      request.param2 = "";
      request.param3 = this.forgotForm.get("CustomerNo").value;
      request.param4 = this.forgotForm.get("MobNo").value;
       //request.param5 =date2['formatted'];
       
       console.log("param5---"+request.param5);
      this.webService.getResponse(request, 'forgotUserName').subscribe((data: IbResponse) => {
        response = data;
        if (response.status === 'S200') {
         sessionStorage.setItem('showSuccessMsg', response.param1);
         this.router.navigate([this.returnUrl]);
          this.spinnerService.hide();
        } else if (response.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
          this.spinnerService.hide();
          this.getCaptcha();
          this.forgotForm.controls['captcha'].setValue('');
        } else {
          this.isError = 'true';
           this.isDisabled = false ;
          // tslint:disable-next-line:no-unused-expression
          response.statusDescription;
          this.errorDescription = response.param1;
          this.isLoad = false;
          this.spinnerService.hide();
          this.getCaptcha();
          this.forgotForm.controls['captchaInput'].setValue('');
        }
       
      });
    }
  }
  
  ngOnInit() {
     this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/show-success';
     this.changePlaceholder();
    this.spinnerService.hide();
   
  }
clearForm()
{
 // this.rForm.setValue({custnumber: '',accno: '',mobno: '',date:'',captcha: '',password:''});
  this.forgotForm.get("CustomerNo").reset();
  this.forgotForm.get("MobNo").reset();
  this.forgotForm.get("date").reset();
  //this.forgotForm.get("captcha").reset();
  this.forgotForm.get("captchaInput").reset();
  this.messageForDatereq='';
}
 validateCustNo()
  {
  console.log("in validation");
    let custno=this.forgotForm.controls['CustomerNo'];
    if (custno.value === '' ||custno.value===' '||custno.value===undefined||custno.value===null) 
    {
     console.log("In iff"+custno.value);
     this.messageForcustnumber = 'no';
     this.Errorflagcust="no";

   }else if(custno.value.match(this.regexpspace))
    {
      this.msgforCustNoSpace= 'no';
      this.Errorflagcust="no";
     }else if(custno.value.match(this.regsplchar))
    {
      this.msgforCustNoSplChar= 'no';
      this.Errorflagcust="no";
     }else if(!custno.value.match(this.regNum))
    {
      this.msgforcustnoonly = 'no';
      this.Errorflagcust="no";
     }else{
       this.Errorflagcust="yes";
     }
     console.log('Errorflagcust-- '+this.Errorflagcust);
 }
  clearCustNo()
  {
     this.messageForcustnumber='';
    this.msgforcustnoonly = '';
    this.msgforCustNoSplChar='';
    this.msgforCustNoSpace= '';
    this.Errorflagcust='yes';
    this.isDisabled=false;
    console.log("this.Errorflagcust"+this.Errorflagcust+"#####"+"this.isDisabled"+this.isDisabled);
  }

  goToLink1(){
    //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
    window.open(this.atmBranch,'_blank');

    //window.location.href='#/Disclaimer';
  }
  goToLink2(){
    // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
    // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
    window.open(this.contactUsPage,'_blank'); 

  }
  
  validateMobNO()
  {
    console.log("mob no.");
     let mobno1=this.forgotForm.controls['MobNo'];
    if (mobno1.value === '' ||mobno1.value===' ' ||mobno1.value===undefined||mobno1.value===null) 
    {
     this.messageFormMobNoreq = 'no';
     this. Errorflagmob="no";
   }else if(mobno1.value.match(this.regexpspace))
    {
      this.msgforMobNoSpace= 'no';
       this. Errorflagmob="no";
     }else if(mobno1.value.match(this.regsplchar))
    {
      this.msgforMobNoSplChar= 'no';
       this. Errorflagmob="no";
     }else if(!mobno1.value.match(this.regNum))
    {
      this.msgforMobNonly = 'no';
       this. Errorflagmob="no";
     }else if(mobno1.value.length>10||mobno1.value.length<10)
    {
      this.msgforMobNoLen = 'no';
       this. Errorflagmob="no";
     }else{
        this. Errorflagmob="yes";
     }
     console.log('Errorflagmob-- '+this.Errorflagmob);
  }  
  
  clearMobNo()
  {
    this.messageFormMobNoreq='';
    this.msgforMobNoSpace='';
    this.msgforMobNoSplChar='';
    this.msgforMobNonly='';
    this.msgforMobNoLen='';
    this.Errorflagmob='yes';
  }
validateDate(event: IMyInputFocusBlur)
  {
    console.log("date");
     let date=this.forgotForm.controls['date'];
    if (date.value === '' ||date.value===' ' ||date.value===undefined||date.value===null) 
    {
     this.messageForDatereq = 'no';
      this. Errorflagdate="no";
   }else{
     this. Errorflagdate="yes";
   }
  }  
  
  clearDate1()
  {
    this.messageForDatereq = '';
  }
 getCaptcha () {
//$rootScope.counter = 180;
      var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
                             'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
                             'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
                              'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
                              'u', 'v', 'w', 'x', 'y', 'z');
      var i;
      for (i = 0; i < 6; i++) {
             var a = alpha[Math.floor(Math.random() * alpha.length)];
             var b = alpha[Math.floor(Math.random() * alpha.length)];
              var c = alpha[Math.floor(Math.random() * alpha.length)];
              var d = alpha[Math.floor(Math.random() * alpha.length)];
             var e = alpha[Math.floor(Math.random() * alpha.length)];
             var f = alpha[Math.floor(Math.random() * alpha.length)];
              var g = alpha[Math.floor(Math.random() * alpha.length)];
       }
      var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f
                + ' ' + g;
                let captcha1= this.forgotForm.controls['captcha'];
               captcha1.setValue(code);
}
  validateCaptcha()
  {
    let captcha=this.forgotForm.controls['captchaInput'];
    let captchaWithoutSpaceNew = this.forgotForm.controls['captcha'].value.split(' ').join('');
    if (captcha.value === '' ||captcha.value===' ' ||captcha.value===undefined||captcha.value===null) 
    {
     this.captchatNoblank = 'no';
     this.Errorflagcap="no";
     
      
   }else if(captcha.value!==captchaWithoutSpaceNew)
     { 
      this.incorrectCaptcha='no';
      this.Errorflagcap="no";
       
    }
    else{
      this.Errorflagcap="yes";
    }
    console.log('Errorflagcap-- '+this.Errorflagcap);
   }
  clearCaptcha()
  {
    this.captchatNoblank='';
    this.incorrectCaptcha='';
    this.Errorflagcap='yes';
  }
 changePlaceholder() {
        this.placeholder = 'Enter Date Of Birth';
    }

  onDateChanged(event: IMyDateModel) {
    
      //console.log("event date---"+JSON.stringify(event.formatted));
     let date1=JSON.stringify(event.formatted);
     let date2=JSON.stringify(event);
     let date3=date1.replace('"','');
     //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     if(event==null){
       this.messageForDatereq = 'no';
     this.Errorflagdate="no";
     }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.messageForDatereq = 'no';
     this.Errorflagdate="no";
   }else{
       this.Errorflagdate="yes";
        this.messageForDatereq='';
   }
     
    }
  

    
    getMonthName(month) 
{ 
return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
}

 
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/forgot-user-id/forgot-user-id.component.ts